const lbaTestFtpConnection = angular.module('app.lbaTestFtpConnection', []);

lbaTestFtpConnection.controller('lbaTestFtpConnectionCtrl', require('./lbaTestFtpConnectionCtrl'));
lbaTestFtpConnection.directive('lbaTestFtpConnection', require('./lbaTestFtpConnectionDir'));

export default lbaTestFtpConnection;



// WEBPACK FOOTER //
// ./src/components/lbaTestFtpConnection/index.js